import React, { FormEvent } from 'react'
import { useForm } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { AuthLayout } from '@/components/layouts/AuthLayout'

interface SetupProps {
  minimum_password_length: number
}

export default function Setup({ minimum_password_length }: SetupProps) {
  const { data, setData, post, processing, errors } = useForm({
    setup: {
      instance_name: '',
      agent: {
        username: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/setup')
  }

  return (
    <AuthLayout title="Instance setup">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Welcome! Set up your Okonomi OS instance by giving it a name and creating the first admin account.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Instance name"
          fullWidth
          autoFocus
          value={data.setup.instance_name}
          onChange={e => setData('setup', { ...data.setup, instance_name: e.target.value })}
          error={'instance_name' in errors}
          helperText={(errors as Record<string, string>)['instance_name']}
          sx={{ mb: 3 }}
        />
        <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
          Admin account
        </Typography>
        <TextField
          label="Username"
          fullWidth
          autoComplete="username"
          value={data.setup.agent.username}
          onChange={e => setData('setup', { ...data.setup, agent: { ...data.setup.agent, username: e.target.value } })}
          error={'agent.username' in errors}
          helperText={(errors as Record<string, string>)['agent.username']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Email"
          type="email"
          fullWidth
          autoComplete="email"
          value={data.setup.agent.email}
          onChange={e => setData('setup', { ...data.setup, agent: { ...data.setup.agent, email: e.target.value } })}
          error={'agent.email' in errors}
          helperText={(errors as Record<string, string>)['agent.email']}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.setup.agent.password}
          onChange={e => setData('setup', { ...data.setup, agent: { ...data.setup.agent, password: e.target.value } })}
          error={'agent.password' in errors}
          helperText={(errors as Record<string, string>)['agent.password'] || `${minimum_password_length} characters minimum`}
          sx={{ mb: 2.5 }}
        />
        <TextField
          label="Password confirmation"
          type="password"
          fullWidth
          autoComplete="new-password"
          value={data.setup.agent.password_confirmation}
          onChange={e => setData('setup', { ...data.setup, agent: { ...data.setup.agent, password_confirmation: e.target.value } })}
          error={'agent.password_confirmation' in errors}
          helperText={(errors as Record<string, string>)['agent.password_confirmation']}
          sx={{ mb: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
        >
          Complete setup
        </Button>
      </Box>
    </AuthLayout>
  )
}
